import React, { useState, useEffect } from "react";
import logo from "../../Assets/Images/h-rooms-01.png";
import WOW from 'wowjs';
import 'animate.css';
import { ApiEndPoint, ApiToken } from "../../Data/Api";
import axios from "axios";
import twitter from '../../Assets/Images/twitterx.svg'
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faSquareWhatsapp,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
// import { ToastContainer, toast } from "react-toastify";
import  { Toaster } from "react-hot-toast";
import { NavLink, useNavigate , Navigate} from "react-router-dom";
import Loader from "../../Components/Loader";
import { setLoginUser } from "../../reducers/hotelActions";
import { useDispatch } from "react-redux";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function Login() {
   useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  const token = ApiToken();
  const baseurl = ApiEndPoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({ username: "", password: "" });
  const [loader, setLoader] = useState(false);
  const [loginerror, setLoginerror] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState("");
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  //   useEffect(()=>{
  // const token = localStorage.getItem("authToken"); // Replace "authToken" with your actual token key
  //   const loginTime = localStorage.getItem("loginTime"); // Timestamp when token was set
  //   const currentTime = new Date().getTime();
  //   // return token ? children : <Navigate to="/login" />;
  //   if (token && loginTime && currentTime - loginTime < 7200000) {
  //     return navigate("/");
  //   }
  //   },[])

   if(localStorage.getItem("authToken")){
     return <Navigate to="/" replace />;
  }

  // const [checkingAuth, setCheckingAuth] = useState(true); // Block UI render until check is done

  // useEffect(() => {
  //   const token = localStorage.getItem("authToken");
  //   const loginTime = localStorage.getItem("loginTime");
  //   const currentTime = new Date().getTime();

  //   if (token && loginTime && currentTime - loginTime < 7200000) {
  //     navigate("/", { replace: true });
  //   } else {
  //     setCheckingAuth(false); // Only show UI if not redirecting
  //   }
  // }, []);

  // if (checkingAuth) {
  //   return null; // Or return a spinner if you like
  // }
  function ValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  function handleChange(e) {
  const { name, value } = e.target;

  setUserData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (submittedOnce && name === "username") {
    if (!ValidEmail(value)) {
      setErrors((prev) => ({
        ...prev,
        username: "Please enter a valid email address.",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.username;
        return updated;
      });
    }
  }
}


  const HandleLogin = async (e) => {
    e.preventDefault();
  setSubmittedOnce(true); // ✅ this is required

  // validate email
  if (!ValidEmail(userData.username)) {
    setErrors((prev) => ({
      ...prev,
      username: "Please enter a valid email address.",
    }));
    return;
  }

    const data = {
      token: token,
      email: userData.username,
      password: userData.password,
    };
    setLoader(true);
    try {
      const response = await axios.post(
        baseurl + "/api/login_customer_submit",
        data,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      setLoader(false);
      if (response.data.status === "error") {
        if (response.data.error_code === 1) {
          setLoginerror(
            "Your account has not been approved from Haramayn Rooms Team. Please wait for 24 to 48 hours or contact at info@haramaynrooms.com."
          );
        } else if (response.data.error_code === 2) {
          setLoginerror("Invalid email or password.");
        } else if (response.data.error_code === 4) {
          setLoginerror("Invalid email or password.");
        } else if (response.data.error_code === 5) {
          setLoginerror(
            "Thank you for your interest. After reviewing your profile, we regret to inform you that it does not meet our criteria and has been declined by the Haramayn Rooms verification team."
          );
        } else {
          setLoginerror(response.data.message);
        }
      } else {
        dispatch(setLoginUser(response.data.b2b_agent));
        const loginTime = new Date().getTime();
        localStorage.setItem("loginTime", loginTime);
        localStorage.setItem("authToken", response.data.b2b_agent.token);
        navigate("/");
      }
    } catch (error) {
      setLoader(false);
      console.error("Error:", error);
    }
  };

  const ForgotPassword = () => {
    localStorage.removeItem("ForgetStepCount");
    navigate("/forgot_password");
  };

  console.log(errors);
  
  return (
    <>
      {loader && <Loader />}
      {/* <ToastContainer /> */}
      <Toaster position="top-right" reverseOrder={false} />
    <div className="">
  <div className="container-fluid vh-100">
    <div className="row h-100">

      {/* Left Column - Welcome Section */}
      <div className="col-lg-5 col-md-5 d-none d-md-flex align-items-center justify-content-center text-white position-relative bg-image wow animate__animated animate__slideInLeft">
  
  {/* Black Overlay */}
  <div className="position-absolute top-0 start-0 w-100 h-100  " style={{background:'#ffffffa6'}}></div>

  {/* Content Above Overlay */}
  <div className="text-center px-4 position-relative text-black">
    <div className="d-flex justify-content-center mt-4">
      <div className="">
        <img src={logo} alt="" className="img-fluid login-logo" />
      </div>
    </div>

    <h4 className="mb-4 ">
      Haramayn Rooms – B2B Hotel Booking Platform for Travel Agents and Umrah Operators
    </h4>

    {/* Contact Details */}
    <div className="align-items-center text-start d-inline-block">
  <p className="mb-2">
    <i className="fa fa-envelope me-2" style={{ fontSize: "13px" }}></i>
    <a 
      href="mailto:info@haramaynrooms.com" 
      className="text-black text-decoration-none fw-normal"
    >
      info@haramaynrooms.com
    </a>
  </p>
  
  <p className="mb-2 ">
    <i className="fa fa-phone me-2" style={{ fontSize: "13px" }}></i>
    <a 
      href="tel:+966509786777" 
      className="text-black text-decoration-none fw-normal"
    >
      +966 50 978 6777
    </a>
  </p>
 <div className="mt-2 d-flex gap-3 mt-3">
     <a
                     href="https://wa.me/966509786777" // Correct format: no +, no spaces
                     target="_blank"
                     rel="noopener noreferrer"
                     className="text-primary fs-4"
                   >
                     <FontAwesomeIcon className="text-danger" icon={faWhatsapp} />
                   </a>
   
                   <a
                     href="https://www.facebook.com/haramaynroom/"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="text-primary fs-4"
                   >
                     <FontAwesomeIcon className="text-danger" icon={faFacebook} />
                   </a>
                   <a
                     href="https://www.instagram.com/haramaynrooms/"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="text-primary fs-4"
                   >
                     <FontAwesomeIcon className="text-danger" icon={faInstagram} />
                   </a>
                   <a
                     href="https://x.com/HaramaynRooms1"
                     target="_blank"
                     rel="noopener noreferrer"
                     className="text-primary fs-4 d-flex"
                   >
                     <img src={twitter} style={{height:'25px', marginTop:'6px'}}  alt="Twitter" className="img-fluid text-danger" />
                   </a>
  </div>
</div>
  </div>
</div>



      {/* Right Column - Login Form */}
      <div className="col-lg-7 col-md-7 col-12 d-flex align-items-center justify-content-center bg-white wow animate__animated animate__slideInRight">
 

  <div className="w-100 px-4 glass-card sign-up">
    {/* Logo for small screens (inside form, above heading) */}
    <div className="text-center  d-block d-lg-none">
      <img src={logo} alt="Haramayn Rooms" className="login-logooo" />
    </div>

    {/* Header */}
    <div className="text-center mb-5">
      <h2 className="fw-bold text-dark mt-2 mb-2">Log In</h2>
      <p className="text-muted">Enter your credentials to access your account</p>
    </div>

    {/* Login Form */}
    <form onSubmit={HandleLogin}>
      {/* Email */}
      <div className="mb-3">
        <label htmlFor="email" className="form-label fw-semibold">
          Email Address
        </label>
        <input
          type="email"
          id="email"
          name="username"
          className="form-control "
          placeholder="Enter your email"
          value={userData.username}
          onChange={handleChange}
          required
        />
        {errors && <div className="text-danger">{errors.username}</div>}
      </div>

      {/* Password */}
      <div className="mb-3">
        <label htmlFor="password" className="form-label fw-semibold">
          Password
        </label>
        <div className="input-group">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            className="form-control "
            placeholder="Password"
            value={userData.password}
            onChange={handleChange}
            required
          />
          <button
            type="button"
            className="btn btn-outline-secondary text-light bg-secondary"
            onClick={togglePassword}
          >
            {showPassword ? (
              <FontAwesomeIcon icon={faEyeSlash} />
            ) : (
              <FontAwesomeIcon icon={faEye} />
            )}
          </button>
        </div>
      </div>
 {loginerror && (
            <div className="text-danger text-center my-2">{loginerror}</div>
          )}
      {/* Forgot Password */}
      <div className="d-flex justify-content-end mb-4">
        <a onClick={ForgotPassword} className="text-primary text-decoration-none" style={{cursor:'pointer'}}>
          Forgot password?
        </a>
      </div>



      {/* Login Button */}
      <button
        type="submit"
        disabled={!userData.username || !userData.password}
        className="btn btn-primary btn-lg w-100 mb-3"
      >
        Log In
      </button>
      

      {/* Register Link */}
      <div className="text-center mb-2">
        <span className="text-muted">Don't have an account? </span>
        <NavLink
          to="/register"
          className="text-primary text-decoration-none fw-semibold"
        >
          Sign up
        </NavLink>
      </div>
        <p className="text-center my-2">
                      © {moment().format("YYYY")} Haramayn Rooms All Rights Reserved
                    </p>
    </form>
    {/* End Form */}
  </div>
</div>

    </div>
  </div>
</div>



    
    </>
  );
}
export default Login;
